import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AppBar,
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import MoreIcon from "@mui/icons-material/MoreVert";
import { getProfile } from "redux/actions/UserProfile";
import { appBarStyle, menuItem } from "./HeaderStyle";
import { headerAuth, headerUnAuth } from "./HeaderData";
import CompanyLogo from "assets/images/companyLogo.svg";
import homeInActive from "assets/images/homeInActive.svg";
import profile from "assets/images/profileImg.svg";

function Header() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const profileData = useSelector(
    (state) => state?.userProfile?.userProfile?.data
  );
  const [profileImg, setProfileImg] = useState(profile);

  const token = localStorage.getItem("token");
  const headerData = token ? headerAuth : headerUnAuth;
  const currentActiveNav = location.pathname.split("/")[1];
  const [selectedIndex, setSelectedIndex] = useState(() => {
    let idToSet = headerData?.find((obj) => obj.path === currentActiveNav)?.id;

    if (idToSet === undefined && currentActiveNav === "ride") {
      idToSet = headerData?.find((obj) => obj.path === "home")?.id;
    }
    return idToSet || 1;
  });
  useEffect(() => {
    setProfileImg(profileData);
  }, [profileData]);
  useEffect(() => {
    if (token) {
      dispatch(getProfile());
    }
  }, []);
  const handleOnError = (e) => {
    e.target.src = "";
  };
useEffect(()=>{
  const currentActiveNav = location.pathname.split("/")[1];
  const idToSet =
    headerData.find((obj) => obj.path === currentActiveNav)?.id ||
    headerData.find((obj) => obj.path === "home")?.id;
  setSelectedIndex(idToSet);
},[location.pathname])
  const onButtonClick = (event, index, data) => {
    setSelectedIndex(index);
   if(data === 'home' && !token) {
      navigate(`/`);
    }
    else{
      navigate(`/${data}`);
      sessionStorage.removeItem('drop');
      sessionStorage.removeItem('pickupLatLng');
      sessionStorage.removeItem('pickup');
      sessionStorage.removeItem('package');
      sessionStorage.removeItem('date');
      sessionStorage.removeItem('paths');
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };
  const handleProfileMenuOpen = () => {
    navigate('/profile')
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const filteredData = headerData.filter((item) => {
    if (item.tokenRequired) {
      return token !== null;
    }
    return true;
  });

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>
        <img className="marginRight8" src={homeInActive} alt="carBlue" />
        <Typography >Home</Typography>
      </MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  
  const onLogin = () => {
    navigate("/login");
  };
  const onSignUp = () => {
    navigate("/signup");
  };

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu 
    style={menuItem}
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {filteredData &&
        filteredData.map((item , index) => (
          <Box key={index}>
          <MenuItem>
            <IconButton
              key={item.id}
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
              disableRipple
              className={`filterBtn  ${
                selectedIndex === item.id ? "colorBlue fontMedium" : " "
              }`}
              onClick={(event) => onButtonClick(event, item.id, item.path)}
            >
              {selectedIndex === item.id ? (
                <img
                  className="marginRight8 wh24"
                  src={item.activeIcon}
                  alt="ActiveIcons"
                />
              ) : (
                <img
                  className="marginRight8 wh24"
                  src={item.icon}
                  alt="DashboardIcons"
                />
              )}
              <Typography>{item.field}</Typography>
            </IconButton>
          </MenuItem>
          </Box>
        ))}
      {token && (
        <MenuItem onClick={handleProfileMenuOpen}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            disableRipple
          >
            <img
              className="wh50"
              src={
                profileImg?.avtar?.url &&
                profileImg?.avtar?.url !== null
                  ? profileImg?.avtar?.url
                  : profile
              }
              alt="profile"
              onError={handleOnError}
            />
          </IconButton>
        </MenuItem>
      )}
      {!token && (
        <Grid item>
          <MenuItem>
            <Button
              size="medium"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              color="inherit"
              className="textCaptialize commonBtn loginBtn"
              onClick={onLogin}
            >
              Login
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              size="medium"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              color="inherit"
              className="textCaptialize commonBtn signupBtn"
              onClick={onSignUp}
            >
              Sign Up
            </Button>
          </MenuItem>
        </Grid>
      )}
    </Menu>
  );

  return (
    <>
      <AppBar position="static" style={appBarStyle}>
          <Toolbar className="marginInline10">
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="height86"
              item
              xs={12}
            >
              <Grid item xs={5}>
                <img
                  className="wh80"
                  src={CompanyLogo}
                  alt="companyLogo"
                />
              </Grid>
              <Grid
                container
                item
                xs={7}
                direction="row"
                justifyContent="end"
                alignItems="center"
                sx={{paddingRight:{xs:'0px',md:'20px'}}}
              >
                <Grid item>
                  <Box sx={{ display: { xs: "none", md: "flex" } }}>
                    {filteredData &&
                      filteredData.map((item) => (
                        <IconButton
                          key={item.id}
                          size="large"
                          aria-label="show 17 new notifications"
                          color="inherit"
                          disableRipple
                          className={`filterBtn ${
                            selectedIndex === item.id
                              ? "colorBlue fontMedium"
                              : " "
                          }`}
                          onClick={(event) =>
                            onButtonClick(event, item.id, item.path)
                          }
                        >
                          {selectedIndex === item.id ? (
                            <img
                              className="marginRight8 wh24"
                              src={item.activeIcon}
                              alt="ActiveIcons"
                            />
                          ) : (
                            <img
                              className="marginRight8 wh24"
                              src={item.icon}
                              alt="DashboardIcons"
                            />
                          )}
                          <Typography
                            className={`${
                              selectedIndex === item.id
                                ? "fontMedium"
                                : "colorGrey"
                            }`}
                          >
                            {item.field}
                          </Typography>
                        </IconButton>
                      ))}
                    {token && (
                      <MenuItem onClick={handleProfileMenuOpen} className="bgTransparent">
                        <IconButton
                          size="large"
                          aria-label="account of current user"
                          aria-controls="primary-search-account-menu"
                          aria-haspopup="true"
                          color="inherit"
                          disableRipple
                        >
                          <img
                            className="wh50"
                            src={
                              profileImg?.avtar?.url &&
                              profileImg?.avtar?.url !== null
                                ? profileImg?.avtar?.url
                                : profile
                            }
                            alt="profile"
                            onError={handleOnError}
                          />
                        </IconButton>
                      </MenuItem>
                    )}
                    {!token && (
                      <>
                        <Button
                          size="medium"
                          edge="end"
                          aria-label="account of current user"
                          aria-controls={menuId}
                          aria-haspopup="true"
                          color="inherit"
                          className=" textCaptialize commonBtn loginBtn marginRight20"
                          onClick={onLogin}
                        >
                          Login
                        </Button>
                        <Button
                          size="medium"
                          edge="end"
                          aria-label="account of current user"
                          aria-controls={menuId}
                          aria-haspopup="true"
                          color="inherit"
                          className="textCaptialize commonBtn signupBtn"
                          onClick={onSignUp}
                        >
                          Sign Up
                        </Button>
                      </>
                    )}
                  </Box>
                  <Box sx={{ display: { xs: "flex", md: "none" } }}>
                    <IconButton
                      size="large"
                      aria-label="show more"
                      aria-controls={mobileMenuId}
                      aria-haspopup="true"
                      onClick={handleMobileMenuOpen}
                      color="inherit"
                    >
                      <MoreIcon />
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
        {renderMenu}
    </>
  );
}

export default Header;
